// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { MovieProvider } from './context/MovieContext';

import HomePage from './pages/HomePage';
import NowPlaying from './pages/NowPlaying';
import ComingSoon from './pages/ComingSoon';
import Membership from './pages/Membership';
import Dining from './pages/Dining';
import Reservation from './pages/Reservation';

// Create a custom theme for Stellar Cinemas
const theme = createTheme({
  palette: {
    primary: {
      main: '#1a237e', // Deep blue for a night sky feel
    },
    secondary: {
      main: '#f5b400', // Gold/yellow for stars
    },
    background: {
      default: '#0a1929', // Dark blue background
      paper: '#122c44', // Slightly lighter blue for cards
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0bec5',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: '10px 24px',
        },
        containedPrimary: {
          background: 'linear-gradient(45deg, #1a237e 30%, #3949ab 90%)',
        },
        containedSecondary: {
          color: '#0a1929',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.09)',
          '&.Mui-focused': {
            backgroundColor: 'rgba(255, 255, 255, 0.15)',
          },
        },
        input: {
          color: '#ffffff',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: 'rgba(255, 255, 255, 0.3)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255, 255, 255, 0.5)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#f5b400',
          },
          backgroundColor: '#1e3a5f',
        },
        input: {
          '&:-webkit-autofill': {
            '-webkit-box-shadow': '0 0 0 100px #1e3a5f inset',
            '-webkit-text-fill-color': '#ffffff',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#1e3a5f',
          '&:hover': {
            backgroundColor: '#234370',
          },
          '&.Mui-focused': {
            backgroundColor: '#234370',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        icon: {
          color: 'rgba(255, 255, 255, 0.7)',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: 'rgba(255, 255, 255, 0.7)',
          '&.Mui-focused': {
            color: '#f5b400',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#1e3a5f',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MovieProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/now-playing" element={<NowPlaying />} />
          <Route path="/coming-soon" element={<ComingSoon />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/dining" element={<Dining />} />
          <Route path="/reservation" element={<Reservation />} />
        </Routes>
      </Router>
      </MovieProvider>
    </ThemeProvider>
  );
}

export default App;